import { internalMessageBus, sbMsgBus } from "../dependencies";
/**
 * @constant
 * @type {BsUtilInitConfig}
 * Default lib configuration
 */
var DefaulLibConfig = {
    internalMsgBus: internalMessageBus,
    externalMsgBus: sbMsgBus,
    externalBroadcastEnabled: false,
    betslip: {
        addSelection: function () { },
        removeSelection: function () { },
        getSelections: function () { return ({}); },
        clearAll: function () { }
    }
};
/**
 * @function setLibConfig Update lib configuration
 * @param {BsUtilInitConfig} config New lib config to be set
 */
export var setLibConfig = function (config) {
    LibConfig.externalMsgBus = config.externalMsgBus;
    LibConfig.internalMsgBus = config.internalMsgBus;
    LibConfig.externalBroadcastEnabled = config.externalBroadcastEnabled;
    LibConfig.betslip = config.betslip;
};
/**
 * Variable used in lib to store current configuration
 */
export var LibConfig = DefaulLibConfig;
//# sourceMappingURL=config.js.map